import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useCurrentUser from '../hooks/useCurrentUser.js';

const RequirePermission = ({ permissions, requireAny = false }) => {
    const { permissions: userPermissions } = useCurrentUser();
    const location = useLocation();

    const allowed = requireAny
        ? Object.keys(permissions).some((key) => {
              const perms = permissions[key];
              return perms.every((perm) => !!userPermissions[key]?.[perm]);
          })
        : Object.keys(permissions).every((key) => {
              const perms = permissions[key];
              return perms.every((perm) => !!userPermissions[key]?.[perm]);
          });

    return allowed ? <Outlet /> : <Navigate to='/unauthorized' state={{ from: location }} replace />;
};

export default RequirePermission;
